export default __webpack_public_path__ + "images/Chak-Prince-Sihanouk-attending-distribution-of-the-sacred-relics.webp";